module.exports = __webpack_public_path__ + "images/external_images/svg/icons/026-pop up.svg";